import styled from "styled-components";
import React from "react";

const Container = styled.button`
  background-color: #FFF;
  border: 1px solid gray;
  border-radius: 4px;
  min-width: 100px;
  margin: 0 1rem;
  padding: .3rem .5rem;
`;


const GoogleButton = ({...otherProps}) => {
    return (
        <Container {...otherProps}/>
    );
};

export default GoogleButton;
